(() => {
  const dialog = document.getElementById('ow-india-stock');
  const localizationForm = document.getElementById('ow-auto-localization');
  if (!dialog || dialog.dataset.initialized) return;
  dialog.dataset.initialized = 'true';

  const popupKey = 'ow-india-stock-shown-v1';
  const countryKey = 'ow-auto-country-v1';
  const preview = Boolean(window.Shopify?.designMode)
    || (window.Shopify?.theme?.role === 'unpublished'
      && new URLSearchParams(window.location.search).get('ow_india_preview') === '1');

  let previousFocus;
  const dismiss = () => dialog.close();
  const show = () => {
    if (typeof dialog.showModal !== 'function' || dialog.open) return;
    try { if (!preview && sessionStorage.getItem(popupKey)) return; } catch (_) {}
    if (document.visibilityState !== 'visible') {
      document.addEventListener('visibilitychange', show, { once: true });
      return;
    }
    previousFocus = document.activeElement;
    dialog.showModal();
    if (!preview) {
      try { sessionStorage.setItem(popupKey, '1'); } catch (_) {}
    }
  };

  dialog.querySelectorAll('[data-ow-india-dismiss]').forEach(button => button.addEventListener('click', dismiss));
  dialog.addEventListener('click', event => {
    if (event.target !== dialog) return;
    const rect = dialog.getBoundingClientRect();
    if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dismiss();
  });
  dialog.addEventListener('close', () => previousFocus?.focus?.({ preventScroll: true }));

  if (preview) {
    show();
    return;
  }

  const controller = new AbortController();
  const timeout = setTimeout(() => controller.abort(), 5000);
  fetch(`${dialog.dataset.root || '/'}browsing_context_suggestions.json?country[enabled]=true`, {
    credentials: 'same-origin',
    signal: controller.signal
  })
    .then(response => response.ok ? response.json() : null)
    .then(data => {
      const detectedCountry = data?.detected_values?.country?.handle;
      if (!detectedCountry) return;

      const desiredCountry = detectedCountry === 'IN' ? 'IN' : 'SG';
      const currentCountry = dialog.dataset.currentCountry;
      let attemptedCountry = '';
      try { attemptedCountry = sessionStorage.getItem(countryKey) || ''; } catch (_) {}

      if (currentCountry !== desiredCountry && attemptedCountry !== desiredCountry && localizationForm) {
        const countryInput = localizationForm.querySelector('[data-ow-country-code]');
        if (countryInput) {
          try { sessionStorage.setItem(countryKey, desiredCountry); } catch (_) {}
          countryInput.value = desiredCountry;
          localizationForm.submit();
          return;
        }
      }

      if (currentCountry === desiredCountry) {
        try { sessionStorage.removeItem(countryKey); } catch (_) {}
      }
      if (desiredCountry === 'IN') show();
    })
    .catch(() => {})
    .finally(() => clearTimeout(timeout));
})();
